/* eslint-disable no-use-before-define */
import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import  {IColabortador} from'../../../interfaces/PerformanceEvaluation.interface'
import Autocomplete, { createFilterOptions, AutocompleteChangeReason, AutocompleteRenderOptionState } from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Checkbox } from "@material-ui/core";

interface CheckmarkSelectProps {
  items: IColabortador[];
  label: string;
  placeholder: string;
  selectAllLabel: string;
  noOptionsText: string;
  limitTags: number;
  onChange: (selected: IColabortador[]) => void;
}

const CheckmarkSelect: React.FC<CheckmarkSelectProps> = ({
  items,
  label,
  placeholder,
  selectAllLabel,
  noOptionsText,
  limitTags,
  onChange
}) => {
  const [selectedOptions, setSelectedOptions] = useState<IColabortador[]>([]);
  const allSelected = items.length === selectedOptions.length;

  const handleToggleOption = (selectedOptions: IColabortador[]) => {
    setSelectedOptions(selectedOptions);
  };

  const handleClearOptions = () => {
    setSelectedOptions([]);
    onChange([]);
  };

  const getOptionLabel = (option: IColabortador) => `${option.bussinesName}`;

  const handleSelectAll = (isSelected: boolean) => {
    if (isSelected) {
      setSelectedOptions(items);
      onChange(items);
    } else {
      handleClearOptions();
    }
  };

  const handleToggleSelectAll = () => {
    handleSelectAll(!allSelected);
  };

  const handleChange = (
    event: React.ChangeEvent<{}>,
    selectedOptions: IColabortador[],
    reason: AutocompleteChangeReason
  ) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find(option => option.id === 0)) {
        handleToggleSelectAll();
        let result = items.filter(el => el.id !== 0);
        onChange(result);
      } else {
        handleToggleOption(selectedOptions);
        onChange(selectedOptions);
      }
    } else if (reason === "clear") {
      handleClearOptions();
    }
  };

  const optionRenderer = (
    option: IColabortador,
    { selected }: AutocompleteRenderOptionState
  ) => {
    const selectAllProps =
      option.id === 0
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 ,
            color: "#FABB00",
          }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };

  const inputRenderer = (params: any) => (
    <TextField {...params} label={label} placeholder={placeholder} variant="outlined"/>
  );

  const getOptionSelected = (option: IColabortador, anotherOption: IColabortador) =>
    option.bussinesName === anotherOption.bussinesName;

  const filter = createFilterOptions<IColabortador>();

  return (
    <Autocomplete
      multiple      
      limitTags={limitTags}
      options={items}
      value={selectedOptions}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [{ bussinesName: selectAllLabel, id: 0 }, ...filtered];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  );
};

CheckmarkSelect.defaultProps = {
  limitTags: 5,
  items: [],
};

export default CheckmarkSelect;
